import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAreaMeasurement = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0076032,
			d: "M243.628 363.886C10.353 427.964 19.766 737.89 225.473 885.409c127.87 91.696 465.903 27.563 594.48-159.29C946.426 542.337 922.118 132.604 779.559 99.78 540.103 44.634 508.472 291.15 243.628 363.886"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0001672,
			d: "M241.45 526.31v203.165-141.164c0-29.97 35.51-67.431 74.048-70.255 36.116-2.666 75.382 27.171 75.382 62.62v148.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0001672,
			d: "M390.85 588.311c0-29.97 35.51-67.431 74.048-70.255 36.116-2.666 75.382 27.171 75.382 62.62v148.8M637.384 320.018c22.542-22.881 84.835-42.308 111.982-2.666 44.962 65.577-100.226 156.41-100.832 179.049h134.16"
		})
	]
});
export default SvgIconAreaMeasurement;
